// extracted by mini-css-extract-plugin
export var container = "Resolution-module--container--7f5d1";
export var eyebrow = "Resolution-module--eyebrow--cf80d";
export var name = "Resolution-module--name--29fff";
export var title = "Resolution-module--title--358c9";